import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import generalStyles from './style/general.module.css';
import colorStyles from './style/color.module.css';

const shapeColors = Object.keys(colorStyles);

const cx = classNames.bind({ ...generalStyles, ...colorStyles });

export default function Shape({
  bottom,
  children,
  color,
  height,
  left,
  right,
  top,
  type,
  width,
}) {
  const initialStyle = {
    top,
    left,
    right,
    bottom,
  };

  const extraStyle =
    width || height
      ? {
          width,
          height,
          maxWidth: '100%',
        }
      : null;

  const shapeClassName = cx('shape', color, type, {
    center: top === '50%' && left === '50%' && !right && !bottom, // center shape only if we haven't set any styles
  });

  const shapeProps = {
    className: shapeClassName,
    style: { ...initialStyle, ...extraStyle },
  };

  return <div {...shapeProps}>{children}</div>;
}

Shape.propTypes = {
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  color: PropTypes.oneOf(shapeColors),
  height: PropTypes.number,
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['losange', 'rectangle', 'square']),
  width: PropTypes.number,
};

Shape.defaultProps = {
  bottom: 0,
  center: true,
  color: 'marvel',
  left: '50%',
  right: 0,
  top: '50%',
  type: 'rectangle',
};



// WEBPACK FOOTER //
// ./src/components/commons/Shape/index.js